module.exports = __webpack_public_path__ + "514e5a277a4c13b4799acc2ecc63232d.svg";